import {connect} from 'react-redux';
import * as modal from '../../reducers/modalReducer';
import { getConfigValue } from '../../reducers/configReducer';
import { secondaryColor } from '../../config/const';
import { getItems, substructProductQnt, increaseProductQnt, removeProduct, cartUpdated } from '../../reducers/cartReducer';
import PurchaseLimitsModal from './PurchaseLimitsModal';
import composedWithTicketCalculator from '../../decorators/WithTicketCalculator';
import { isPhoneSelector } from '../../selectors/configSelectors';

const mapStateToProps = (state) => {
  return {
    secondaryColor: getConfigValue(secondaryColor, state),
    summary: state.summary.summary,
    items: getItems(state),
    purchaseLimitsExceeded: state.summary.purchaseLimitsExceeded,
    isPhone: isPhoneSelector(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideModal: () => dispatch(modal.hideModal()),
    increaseProductQnt: (productId) => {
      dispatch(increaseProductQnt(productId));
      dispatch(cartUpdated());
    },
    substructProductQnt: (productId) => {
      dispatch(substructProductQnt(productId));
      dispatch(cartUpdated());
    },
    removeProduct: (productId) => {
      dispatch(removeProduct(productId));
      dispatch(cartUpdated());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(composedWithTicketCalculator(PurchaseLimitsModal));



// WEBPACK FOOTER //
// ./src/components/PurchaseLimitsModal/PurchaseLimitsContainer.jsx